import { render, staticRenderFns } from "./ProductShell.vue?vue&type=template&id=5657f7a4&"
import script from "./ProductShell.vue?vue&type=script&lang=js&"
export * from "./ProductShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports